import { render, staticRenderFns } from "./EmergencyContactsAndVaccinations.vue?vue&type=template&id=172fefff&scoped=true"
import script from "./EmergencyContactsAndVaccinations.vue?vue&type=script&lang=js"
export * from "./EmergencyContactsAndVaccinations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172fefff",
  null
  
)

export default component.exports